export default __webpack_public_path__ + "static/media/qrcode.d4a11174.png";